import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "my-3" }
const _hoisted_2 = { key: 1 }

import { watch } from 'vue';
import { useQuery } from '@vue/apollo-composable';
import { StatsDocument } from '@/gql/graphql';
import { BAlert, BButton, BSpinner } from 'bootstrap-vue-next';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

/* GRAPHQL API DETAILS ***********************************************/

export default /*@__PURE__*/_defineComponent({
  __name: 'AdminStatsView',
  setup(__props) {

const {
  result: resultFetchData,
  loading: fetchingData,
  error: errorFetchingData,
  refetch: refetchDetails,
} = useQuery(StatsDocument);

// Handle the result of the currentUser query
watch(resultFetchData, (value) => {
  console.log(value);
  if (value) {
    console.log('Stats fetched');
  } else {
    console.log('Fetching stats failed');
  }
});

/* GRAPHQL API - RE-FETCH DATA WHEN VIEW ACTIVATED ***************************/

function requestRefetchDetails() {
  refetchDetails()
    ?.catch((err) => {
      console.error('Refetching stats failed:', err);
    })
    .then(() => {
      console.log('refetched');
    });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h1", null, [
      _createVNode(_unref(FontAwesomeIcon), { icon: ['fas', 'chart-simple'] }),
      _cache[1] || (_cache[1] = _createTextVNode(" Analytics Cloud Stats ", -1))
    ]),
    _cache[7] || (_cache[7] = _createElementVNode("h5", null, "Browse stats and check cloud resource usage", -1)),
    _cache[8] || (_cache[8] = _createElementVNode("hr", null, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(BAlert), {
        modelValue: _unref(errorFetchingData),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(errorFetchingData) ? (errorFetchingData).value = $event : null)),
        variant: "danger",
        class: "mt-3"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(errorFetchingData)) + " ", 1),
          _createVNode(_unref(BButton), {
            onClick: requestRefetchDetails,
            variant: "outline-dark",
            class: "btn-sm"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(FontAwesomeIcon), { icon: ['fas', 'sync'] }),
              _cache[2] || (_cache[2] = _createTextVNode(" Retry", -1))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      (_unref(fetchingData))
        ? (_openBlock(), _createBlock(_unref(BAlert), {
            key: 0,
            variant: "info",
            class: "mt-3"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(BSpinner), {
                small: "",
                label: "Loading..."
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_unref(resultFetchData))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("p", null, [
              _cache[3] || (_cache[3] = _createElementVNode("strong", null, "Organizations registered: ", -1)),
              _createTextVNode(_toDisplayString(_unref(resultFetchData).stats?.organizations), 1)
            ]),
            _createElementVNode("p", null, [
              _cache[4] || (_cache[4] = _createElementVNode("strong", null, "Users registered: ", -1)),
              _createTextVNode(_toDisplayString(_unref(resultFetchData).stats?.users), 1)
            ]),
            _createElementVNode("p", null, [
              _cache[5] || (_cache[5] = _createElementVNode("strong", null, "Projects: ", -1)),
              _createTextVNode(_toDisplayString(_unref(resultFetchData).stats?.projects), 1)
            ]),
            _createElementVNode("p", null, [
              _cache[6] || (_cache[6] = _createElementVNode("strong", null, "Storage Buckets In-Use: ", -1)),
              _createTextVNode(_toDisplayString(_unref(resultFetchData).stats?.buckets), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})